import React from "react";
import "./WhatsAppChat.css"; // Create this CSS file

const WhatsAppChat = ({ phoneNumber, message }) => {
  // Format the WhatsApp URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-chat"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12.036 2C6.364 2 2 6.364 2 12c0 2.073.67 3.989 1.803 5.558L2 22l4.442-1.803A9.923 9.923 0 0012 22c5.636 0 10-4.364 10-10S17.636 2 12.036 2zm4.69 12.08c-.315-.075-1.88-.44-2.17-.49-.29-.05-.562-.125-.82.125-.258.25-.996.98-1.223 1.177-.227.197-.453.222-.84.075-.387-.147-1.628-.497-3.1-1.585-1.237-1.04-2.047-2.33-2.287-2.728-.24-.397-.013-.61.184-.803.192-.188.422-.467.635-.702.213-.234.282-.397.422-.647.14-.25.07-.472-.025-.658-.096-.185-.852-2.015-.85-2.218.002-.203-.36-.397-.76-.397-.4 0-.803.044-1.217.22-.413.177-1.135.454-1.614 1.31-.48.856-.768 2.147-.768 3.53 0 5.437 4.43 9.863 9.864 9.863 2.672 0 5.228-.985 7.14-2.79.858-.79 1.535-1.765 1.916-2.58.38-.814.38-1.514.284-1.657-.097-.143-.416-.233-.73-.308z" />
      </svg>
      <span className="whatsapp-text">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppChat;